module.exports = __webpack_public_path__ + "static/media/EHallCorner.24248709.webp";